function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg256Georgia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "129.855,92.753 129.855,55.652 92.753,55.652 92.753,92.753 55.652,92.753 55.652,129.855    92.753,129.855 92.753,166.957 129.855,166.957 129.855,129.855 166.957,129.855 166.957,92.753  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "419.247,92.753 419.247,55.652 382.145,55.652 382.145,92.753 345.043,92.753    345.043,129.855 382.145,129.855 382.145,166.957 419.247,166.957 419.247,129.855 456.348,129.855 456.348,92.753  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "129.855,382.145 129.855,345.043 92.753,345.043 92.753,382.145 55.652,382.145    55.652,419.247 92.753,419.247 92.753,456.348 129.855,456.348 129.855,419.247 166.957,419.247 166.957,382.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "419.247,382.145 419.247,345.043 382.145,345.043 382.145,382.145 345.043,382.145    345.043,419.247 382.145,419.247 382.145,456.348 419.247,456.348 419.247,419.247 456.348,419.247 456.348,382.145  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    style: {
      fill: "#D80027"
    },
    width: 64,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 224,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg256Georgia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };